// libs
import axios from "axios";
import { LOCAL_STORAGE } from "./constants/localStorageConstants";
import { getDomainName } from "@dx-hrsol/util-kit";

const { AUTHORITIES, SELECTED_BRANCH, CURRENT_ORGANIZATION, BRANCHES } =
  LOCAL_STORAGE;

const API_URL = process.env.REACT_APP_API_URL.replace("{0}", getDomainName());
const SSO_CLIENT = process.env.REACT_APP_SSO_CLIENT;
const SOCKET_SERVER = process.env.REACT_APP_SOCKET_SERVER.replace(
  "{0}",
  getDomainName()
);

const FCM_CONFIG = {
  apiKey: process.env.REACT_APP_FCM_API_KEY,
  authDomain: process.env.REACT_APP_FCM_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FCM_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FCM_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FCM_MESSAGE_SENDER_ID,
  appId: process.env.REACT_APP_FCM_APP_ID,
  measurementId: process.env.REACT_APP_FCM_MEASUREMENT_ID,
};
const FCM_VAPID_KEY = process.env.REACT_APP_FCM_VAPID_KEY;
const ANALYTICS_MEASUREMENT_ID = process.env.REACT_APP_ANALYTICS_MEASUREMENT_ID;
const SSO_URL = process.env.REACT_APP_SSO_URL;
const QT_API = process.env.REACT_APP_QT_API;
const HRSOL_CONTACT = process.env.REACT_APP_HRSOL_CONTACT;

//CREATE COMMON AXIOS
export const AXIOS_INSTANCE = axios.create({
  baseURL: API_URL,
});

const NATION_ZONE_DATA = [
  {
    code: "vn",
    name: "vietnam",
    zone: "Asia/Ho_Chi_Minh",
    offset: "+07:00",
  },
  {
    code: "jp",
    name: "japan",
    zone: "Asia/Tokyo",
    offset: "+09:00",
  },
];

function objectToForm(object) {
  var form_data = new FormData();
  for (var key in object) {
    form_data.append(key, object[key]);
  }
  return form_data;
}

//Handle Crop Image
function getCroppedImg(image, crop, fileName) {
  const canvas = document.createElement("canvas");
  const scaleX = image.naturalWidth / image.width;
  const scaleY = image.naturalHeight / image.height;
  canvas.width = crop.width;
  canvas.height = crop.height;
  const ctx = canvas.getContext("2d");

  ctx.drawImage(
    image,
    crop.x * scaleX,
    crop.y * scaleY,
    crop.width * scaleX,
    crop.height * scaleY,
    0,
    0,
    crop.width,
    crop.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob(
      (blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        blob.lastModifiedDate = new Date();
        // window.URL.revokeObjectURL(this.fileUrl);
        // this.fileUrl = window.URL.createObjectURL(blob);
        resolve(blob);
      },
      "image/png",
      1
    );
  });
}

let timeout;

const getListUserForSearchFilterCalendar = (valueSearch, callback) => {
  if (timeout) {
    clearTimeout(timeout);
    timeout = null;
  }

  const url = `/api/${
    JSON.parse(localStorage.getItem(SELECTED_BRANCH))["code"]
  }/users/list`;

  const callAPI = () => {
    AXIOS_INSTANCE.request({
      url: url,
      method: "get",
      params: { keyword: valueSearch, locked: true },
    }).then((res) => {
      callback(res.data);
    });
  };

  timeout = setTimeout(callAPI, 700);
};

function getContrastColor(color) {
  //if only first half of color is defined, repeat it
  if (color.length < 5) {
    color += color.slice(1);
  }
  return color.replace("#", "0x") > 0xffffffff / 2 ? "#333" : "#fff";
}

function getCurrentOrganizationJSON() {
  return JSON.parse(localStorage.getItem(CURRENT_ORGANIZATION) || []);
}

function getCurrentBranchJSON() {
  return JSON.parse(localStorage.getItem(SELECTED_BRANCH) || []);
}

function getCurrentZoneId() {
  return localStorage.getItem(SELECTED_BRANCH)
    ? JSON.parse(localStorage.getItem(SELECTED_BRANCH)).zone.split(":")[1]
    : "";
}

function getAllBranchJSON() {
  return JSON.parse(localStorage.getItem(BRANCHES));
}

function dateConvert(fromDate, toDate) {
  const dateConvert = {
    fromDateConvert: fromDate !== "" ? `${fromDate}T00:00:00Z` : null,
    toDateConvert: toDate !== "" ? `${toDate}T23:59:59Z` : null,
  };
  return dateConvert;
}

function getAllBranchNormalizeMode(allBranches) {
  const branches =
    allBranches && !!allBranches.length
      ? allBranches
      : JSON.parse(localStorage.getItem(BRANCHES));
  return branches.reduce((prev, cur) => ({ ...prev, [cur.code]: cur }), {});
}

function getAllAuthoritiesJSON() {
  return JSON.parse(localStorage.getItem(AUTHORITIES));
}

function getRoleColor(value) {
  switch (value) {
    case "SUPER_ADMIN":
      return "volcano";
    case "ADMIN":
      return "volcano";
    case "MANAGER":
      return "gold";
    case "ACCOUNTANT":
      return "gold";
    case "SUB_MANAGER":
      return "purple";
    case "NORMAL_USER":
      return "cyan";
    case "MANAGER_USER":
      return "red";
    default:
      return "cyan";
  }
}

function getLockColor(isNonLocked) {
  return isNonLocked ? "green" : "volcano";
}

function getLockDisplayText(isNonLocked) {
  return isNonLocked ? "ACTIVE" : "LOCKED";
}

const MAX_MONEY_AMOUNT = 999999999999;

function formatMoneyValue(value) {
  return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,"); // add comma
}

function handleMoneyValue(value) {
  var result = "";
  var fixedValue = value
    .toString()
    .replace(/[^0-9.]/g, "") // remove non-numbers
    .replace(/(\..*)\./g, "$1"); // remove redundant dot
  if (fixedValue.endsWith(".")) {
    result = formatMoneyValue(fixedValue);
  } else {
    var numberValue = parseInt(Number(fixedValue) * 100) / 100;
    if (numberValue > MAX_MONEY_AMOUNT) {
      numberValue = MAX_MONEY_AMOUNT;
    }
    result = formatMoneyValue(numberValue);
  }
  return result;
}

export const removeDuplicate = (list) => {
  let newList = [];
  if (list && list.length !== 0) {
    list.forEach((item) => {
      const check = newList.filter(
        (ele) => ele.employeeCode === item.employeeCode
      );
      if (check.length === 0) {
        newList.push(item);
      }
    });
  }
  return newList;
};

export const formatCost = (str) => {
  if (str) {
    const v1 = str.toString().replace(/\$\s?|(,*)/g, "");
    return `${v1}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " VND";
  }
  return "";
};

export const formatCostNotSuffix = (str) => {
  if (str) {
    const v1 = str.toString().replace(/\$\s?|(,*)/g, "");
    return `${v1}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return "";
};

const DEFAULT_ORG_CODE = "citynow-org";
const ENV_ORG_CODE = process.env.REACT_APP_ORG_CODE;

export const getOrgCode = (str) => {
  return (
    ENV_ORG_CODE ||
    (str.includes("localhost") ? DEFAULT_ORG_CODE : str.split(".")[0])
  );
};

export const parseJwt = (token) => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map((c) => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join("")
  );

  return JSON.parse(jsonPayload);
};

export {
  NATION_ZONE_DATA,
  SOCKET_SERVER,
  API_URL,
  SSO_CLIENT,
  SSO_URL,
  FCM_CONFIG,
  FCM_VAPID_KEY,
  QT_API,
  HRSOL_CONTACT,
  ANALYTICS_MEASUREMENT_ID,
  getCroppedImg,
  objectToForm,
  getListUserForSearchFilterCalendar,
  getContrastColor,
  getCurrentBranchJSON,
  getAllBranchJSON,
  getRoleColor,
  getLockColor,
  getLockDisplayText,
  getAllAuthoritiesJSON,
  getCurrentZoneId,
  getCurrentOrganizationJSON,
  formatMoneyValue,
  handleMoneyValue,
  getAllBranchNormalizeMode,
  dateConvert,
};
